import { __cCreatorCampaignService } from '@/services/client/__c.creator-campaign.service'
import { useQuery } from '@tanstack/react-query'

export const useCreatorCampaigns = () => {
  return useQuery({
    queryKey: ['creator-campaigns'],
    queryFn: () => __cCreatorCampaignService.getCreatorCampaigns(),
  })
}
